(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  // Purchase selector -> the form's hidden `selling_plan` field.
  // One-time posts an empty selling_plan; the subscription option
  // posts the plan id. No price is computed here — every figure on
  // the page is a section setting rendered server-side.
  (function () {
    document.querySelectorAll('[data-sbp-section="hero"]').forEach(function (root) {
      var planField = root.querySelector('[data-sbp-selling-plan]');
      if (planField) {
        root.querySelectorAll('[data-sbp-option]').forEach(function (input) {
          input.addEventListener('change', function () {
            if (input.checked) planField.value = input.value;
          });
        });
      }

      // The signature stroke was removed on 5 Sep 2026 (Mohamed:
      // "the stroke idea is bad ... it feels non sense thing that
      //  has no meaning"), and the IntersectionObserver that
      // revealed it went with it. Nothing replaces it here - the
      // section label above the heading is the marker now.

      // Thumbnail -> main image swap. Progressive enhancement:
      // with JS off the main image still renders.
      var figure = root.querySelector('[data-sbp-hero-figure]');
      var mainImg = figure ? figure.querySelector('img') : null;
      var thumbs = root.querySelectorAll('[data-sbp-thumb]');
      if (!mainImg || !thumbs.length) return;
      var originalSrc = mainImg.getAttribute('src');
      var originalSrcset = mainImg.getAttribute('srcset');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var full = btn.getAttribute('data-sbp-full');
          if (!full) return;
          var isActive = btn.getAttribute('aria-current') === 'true';
          thumbs.forEach(function (b) { b.removeAttribute('aria-current'); });
          if (isActive) {
            mainImg.setAttribute('src', originalSrc);
            if (originalSrcset) mainImg.setAttribute('srcset', originalSrcset);
            return;
          }
          mainImg.removeAttribute('srcset');
          mainImg.setAttribute('src', full);
          var inner = btn.querySelector('img');
          if (inner && inner.alt) mainImg.setAttribute('alt', inner.alt);
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-prod-hero"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sbx-hero]').forEach(function (root) {
      var main = root.querySelector('[data-sbx-main] img');
      var thumbs = root.querySelectorAll('[data-sbx-thumb]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var full = btn.getAttribute('data-sbx-full');
          if (!main || !full || btn.getAttribute('aria-current') === 'true') return;
          thumbs.forEach(function (b) { b.removeAttribute('aria-current'); });
          btn.setAttribute('aria-current', 'true');
          var inner = btn.querySelector('img');
          var swap = function () {
            main.removeAttribute('srcset');
            main.setAttribute('src', full);
            if (inner && inner.alt) main.setAttribute('alt', inner.alt);
            main.classList.remove('is-swapping');
          };
          if (reduce) { swap(); return; }
          main.classList.add('is-swapping');
          setTimeout(swap, 200);
        });
      });

      var select = root.querySelector('[data-sbx-variant]');
      if (select) {
        select.addEventListener('change', function () {
          var price = select.options[select.selectedIndex].getAttribute('data-price');
          var now = root.querySelector('[data-sbx-price]');
          if (now) now.textContent = price;
          root.querySelectorAll('[data-sbx-was], [data-sbx-save]').forEach(function (el) { el.hidden = true; });
        });
      }

      var qty = root.querySelector('[data-sbx-qty-input]');
      root.querySelectorAll('[data-sbx-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var next = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-sbx-qty'), 10);
          qty.value = Math.min(99, Math.max(1, next));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smileboxx-footer"] && !Shopify.designMode) return;
  try {
    
  // Section 04: "Never show two sticky CTAs at once."
  // The theme emits exactly one, so this only fires if a future
  // section or an app injects a second. Keep the first in the
  // document and remove the rest.
  (function () {
    const enforceSingleStickyCta = () => {
      const bars = document.querySelectorAll('[data-sb-sticky-cta]');
      for (let i = 1; i < bars.length; i++) bars[i].remove();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enforceSingleStickyCta);
    } else {
      enforceSingleStickyCta();
    }
    document.addEventListener('shopify:section:load', enforceSingleStickyCta);
  })();

  } catch(e) { console.error(e); }
})();
})();
